import classNames from 'classnames';

import { Toggle } from '@hcs/design-system';
import { ControlPosition } from '@hcs/types';

import { useHcMap } from '../../hooks';

import styles from './ClusterToggle.module.css';

interface Props {
  mapId: string;
  className?: string;
  position: ControlPosition;
}
const OPTIONS = [
  {
    label: 'Cluster On',
    value: true,
  },
  {
    label: 'Cluster Off',
    value: false,
  },
];
const dataHcName = 'cluster-toggle';
export const ClusterToggle = ({ mapId, className, position }: Props) => {
  const {
    mapState,
    actions: { hcMapDisableMarkerClusters },
  } = useHcMap(mapId);
  return (
    <Toggle
      secondary
      dataHcName={`${dataHcName}-cluster-toggle`}
      className={classNames(className, styles[position])}
      options={OPTIONS}
      value={!mapState?.markers.disableClusters}
      onChange={(v) =>
        hcMapDisableMarkerClusters({ mapId, disableClusters: !v })
      }
    />
  );
};
